// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__92oqo","rightAdornment":"Header_rightAdornment__3YEnD"};